/**
 * jQuery Plugin: SecondaryNav
 *
 * This plugin provides secondary navigation functionality for responsive web layouts.
 * It is based on the secondary navigation functionality from the ElonUniversity-Base theme,
 * specifically from `assets/js/global/components/widgets/SecondaryNav/src/jquery.SecondaryNav.js`.
 * 
 * Modifications Made:
 * - Adapted to account for differences in template markup, specifically:
 *   - Adjusted selectors for navigation wrapper and parent.
 *   - Refined scroll behavior and hash handling to fit the new structure.
 *   - Simplified initialization logic to be more consistent with the updated markup.
 * 
 * Features:
 * - Adds a mobile toggle button to show or hide the secondary navigation on smaller screens.
 * - Moves the navigation element based on the screen width to ensure proper visibility and layout.
 * - Handles the addition and removal of "current" classes based on scroll position and clicks.
 * - Updates navigation links to handle hash fragments properly, considering potential structure differences.
 * 
 * Options:
 * - `navJumpWidth`: The maximum width at which the navigation will be moved to a different location (default: 991).
 * - `hashUpdateScrollDelay`: Delay in milliseconds before updating the hash in the URL based on scroll position (default: 500).
 * 
 * Usage:
 * Initialize the plugin on a navigation element by calling the `SecondaryNav` method.
 * Example:
 * $('nav', '#pageSidebar').SecondaryNav();
 * 
 * Methods:
 * - $.fn.SecondaryNav(options): Initializes the secondary navigation plugin on the selected elements.
 * - $.fn.SecondaryNav.checkScroll(direction, nav, doingClick): Handles scroll events to update the "current" menu item based on the scroll direction.
 * - $.fn.SecondaryNav.getPosition(element): Calculates the vertical offset position of an element.
 * - $.fn.SecondaryNav.getMobileButton(nav): Creates and returns the mobile toggle button for the navigation.
 *
 * @param {Object} [opts={}] - Options to customize the plugin behavior.
 * @param {number} [opts.navJumpWidth=991] - The maximum screen width where the navigation will be repositioned.
 * @param {number} [opts.hashUpdateScrollDelay=500] - Delay before updating the URL hash based on scroll position.
 * 
 * @returns {jQuery} The jQuery object to allow for method chaining.
 */
(function($) {
	$.fn.SecondaryNav = function(opts) {
		opts = $.extend({}, $.fn.SecondaryNav.options, opts);
		
		this.each(function() {
			var el = $(this);
			var nav = el.children('ul');
            var wrapper = $('#sidebarNavWrap');
            var wrapperParent = $('#pageSidebar');
			var navRow = nav.closest('.row');
			
			nav.parent().find('#secondary-nav-toggle').remove(); // remove any existing button, in case this plugin has already been initialized (used by DirectoryProfile.js, for example)
			
			var mobileButton = $.fn.SecondaryNav.getMobileButton(nav);
			
			nav.before(mobileButton);
	
			function checkWidth() {
				var width = $(window).width();
				
				if (width <= opts.navJumpWidth) {
                    
					if (navRow.children().first().is(wrapper) === false) {
						// move nav to first child in .row
						wrapper.prependTo(navRow);
						nav.slideUp(0);
					}
                    
				} else {

                    if (wrapperParent.children().first().is(wrapper) === false) {
                        // move nav wrapper to original parent
                        wrapperParent.prepend(wrapper);
                        nav.slideDown(0);
                    }
					
				}
			}
	
			$(window).resize(function(){
				checkWidth();
			});
	
			checkWidth();
			
			var links = nav.find('a');
			
			var currPage = window.location.href;
			
			/**
			 * Handle hash only vs. full URL
			 */
			 
			// Loop through all found links in nav
			$(links).each(function(idx, ele) {
				var link = $(this).attr('href');
				
				// Only proceed if: 1) a hash is present, and 2) the hash isn't empty (for example, a placeholder menu item)
				if (link.indexOf('#') !== -1 && link.split('#')[1] !== '') {
					var linkParts = link.split('#');
					
					// Only modify anchor-only links
					if (linkParts[0] == '') {
						// Submenu anchor: prefix with parent page
						if ($(this).closest('.sub-menu').length) {
							var parentPage = $(this).closest('.sub-menu').parent().children('a').attr('href');
							
							if (parentPage) {
								var updatedLink = parentPage + link;
								$(this).attr('href', updatedLink);
							}
						} else {
							// Top-level anchor: prefix with the first top-level menu item's href
							var firstTopLevelLink = $('#sidebarNavWrap .nav > li > a[href^="http"], #sidebarNavWrap .nav > li > a[href^="/"]')
								.first()
								.attr('href');
							
							if (firstTopLevelLink) {
								var updatedLink = firstTopLevelLink + link;
								$(this).attr('href', updatedLink);
							}
						}
					}
				}
			});
			
			/**
			 * Perform desired click actions
			 */
			
			var doingClick = false;
			
			// Add necessary "current" classes to the menu item when clicked
			$(nav).on('click', 'a[href*="#"]', function() {
				
				var url = $(this).attr('href');
				var hash = url.split('#')[1];
				
				$('a.scrolled').removeClass('scrolled');
				$('a[id="' + hash + '"]').addClass('scrolled');
				
				doingClick = true;
				$('.bellows-current-menu-item').removeClass('bellows-current-menu-item bellows-current_page_item');
				$(this).parent().addClass('bellows-current-menu-item bellows-current_page_item');
				
				
			});
			
			// Reset "doingClick" var
			document.addEventListener('wheel', function() {
				doingClick = false;
			});
			
			/**
			 * Perform desired scroll actions
			 */
			var lastScrollTop = 0;
			$(window).scroll(function() {
				
				var st = $(this).scrollTop();
				if (st > lastScrollTop) {
					// down scroll
					$.fn.SecondaryNav.checkScroll('down', nav, doingClick);
				} else {
					// up scroll
					$.fn.SecondaryNav.checkScroll('up', nav, doingClick);
				}
				
				lastScrollTop = st;
				
			});
			
		});
		
		return this;
	};
	
	$.fn.SecondaryNav.checkScroll = function(direction, nav, doingClick) {
		
		if (doingClick == false) {
		
			var hashes = $(nav).find('a[href*="#"]');
			
			for (var i=0; i < hashes.length; i++) {
						
				var href = $(hashes[i]).attr('href');
				var hash = href.split('#')[1];
				var anchor = $('.page--main-content').find('a[id="' + hash + '"]');
				var anchorPos = $(anchor).offset();
				var offset = $.fn.SecondaryNav.getPosition(anchor[0]);
				var trigger = document.documentElement.scrollTop;
				
				// remove "scrolled" class if we've
				if (offset > trigger && $(anchor).hasClass('scrolled')) {
					$(anchor).removeClass('scrolled');
				}
				
				if (direction == 'down') {
					
					if (offset < trigger && !$(anchor).hasClass('scrolled')) {
						
						$(anchor).addClass('scrolled');
						$('.bellows-current-menu-item').removeClass('bellows-current-menu-item bellows-current_page_item');
						$(hashes[i]).parent().addClass('bellows-current-menu-item bellows-current_page_item');
						
						break;
						
					}
					
				} else {
					
					if (offset > trigger && !$(anchor).hasClass('scrolled')) {
						
						$('.bellows-current-menu-item').removeClass('bellows-current-menu-item bellows-current_page_item');
						
						if ($(window).scrollTop() == 0) {
							
							$(anchor).removeClass('scrolled'); // go ahead and remove all scolled classes
							$(hashes[i]).parent().parent().prev().parent().addClass('bellows-current-menu-item bellows-current_page_item');	
							
						} else {
						
							$(anchor).addClass('scrolled');
							$(hashes[i]).parent().addClass('bellows-current-menu-item bellows-current_page_item');
						
						}
						
						break;
						
					}
					
				}
				
			}
			
		}
		
	}
	
	$.fn.SecondaryNav.getPosition = function(element) {
		
		if (element) {
		
			var distance = 0;
			
			do {
				distance += element.offsetTop;
				element = element.offsetParent;
			} while (element);
			
			return distance < 0 ? 0 : distance;
		
		}
		
	}
	
	$.fn.SecondaryNav.getMobileButton = function(nav) {
		// create hidden mobile nav button
		var mobileButton = $('<a href="#" id="secondary-nav-toggle" class="page-nav--mobile-toggle link-plain"></a>');
		mobileButton.html('Menu<i class="fal fa-plus" aria-hidden="true"></i>');

		mobileButton.click(function(){
			if (nav.is(':visible')) {
                mobileButton.addClass('nav-closed').removeClass('nav-open');
				nav.slideUp('fast');
			} else {
                mobileButton.addClass('nav-open').removeClass('nav-closed');
				nav.slideDown('down');
			}
	
			return false;
		});
		
		return mobileButton;
	};
	
	$.fn.SecondaryNav.options = {
		navJumpWidth: 991,
		hashUpdateScrollDelay: 500
	};
	
}(jQuery));

/**
 * Initializes the SecondaryNav plugin for the navigation within the page sidebar.
 * 
 * This initialization is based on the SecondaryNav functionality from the 
 * ElonUniversity-Base theme (assets/js/global/components/widgets/SecondaryNav/src/jquery.SecondaryNav.js).
 * Note that in the ElonUniversity-Base theme, SecondaryNav was initialized 
 * separately, but here it is included directly within this script.
 * 
 * The plugin is only initialized if the SecondaryNav function is available and
 * there is a `<nav>` element within the `#pageSidebar` element.
 */
$(function() {
    if (typeof $({}).SecondaryNav === 'function' && $('nav', '#pageSidebar')[0]) {
        $('nav', '#pageSidebar').SecondaryNav();
    }
});